module.exports = __webpack_public_path__ + "static/media/LOGO_ENERGIA_SOMAR.48a72d6b.svg";